<!--
 * @Author: Scarlett Xiao
 * @Date: 2022-01-04 15:05:32
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-03-10 11:26:29
-->
<template>
  <!-- 养成销售概览 -->
  <div class="content-wrap">
    <div class="page-list">
      <div class="page-type-switch">
        <div
          :class="pageType === 'volume' ? 'type-activite' : ''"
          @click="pageType = 'volume'"
        >
          销售量
        </div>
        <div
          :class="pageType === 'customer' ? 'type-activite' : ''"
          @click="pageType = 'customer'"
        >
          客户应收
        </div>
      </div>
      <!-- 销售量 -->
      <VolumePage v-if="pageType === 'volume'" />
      <!-- 客户应收 -->
      <CustomerPage v-if="pageType === 'customer'" />
    </div>
  </div>
</template>

<script>
import VolumePage from "./yc-sales-volume/yc-sales-volume.vue";
import CustomerPage from "./yc-sales-customer.vue";
export default {
  name: "yc-sales",
  data() {
    return {
      pageType: "volume",
    };
  },
  computed: {},
  methods: {},
  components: {
    VolumePage,
    CustomerPage,
  },
};
</script>

<style lang="less" scoped>
</style>